let MediaQueryTarget = /*#__PURE__*/function (MediaQueryTarget) {
  MediaQueryTarget["Mobile"] = "mobile";
  MediaQueryTarget["Phablet"] = "phablet";
  MediaQueryTarget["Tablet"] = "tablet";
  MediaQueryTarget["Desktop"] = "desktop";
  MediaQueryTarget["Widescreen"] = "widescreen";
  MediaQueryTarget["Landscape"] = "landscape";
  MediaQueryTarget["PrefersReducedMotion"] = "prefersReducedMotion";
  MediaQueryTarget["MobileCommon"] = "mobileCommon";
  return MediaQueryTarget;
}({});

// NOTE: Would prefer to utilize `MediaQueryTarget` + string value.

export { MediaQueryTarget };
